import { render, staticRenderFns } from "./FavButton.vue?vue&type=template&id=f758f852&scoped=true&"
import script from "./FavButton.vue?vue&type=script&lang=js&"
export * from "./FavButton.vue?vue&type=script&lang=js&"
import style0 from "./FavButton.vue?vue&type=style&index=0&id=f758f852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f758f852",
  null
  
)

export default component.exports